/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React, { useRef, useEffect, Suspense, useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
const Modal = React.lazy(() => import('@web-components/common/Modal'));
import { data as Font } from '~global/Fonts';
const Button = React.lazy(() => import('@web-components/form/Button'));
import ProductUtils from '~global/utils/product';
import { GoogleTagManager } from '~global/sociolla.dm.lib';
import * as cartActions from '~store/cart/actions/cart';
const ModalAddToBagPreOrderWarning = ({ navigation }) => {
  const dispatch = useDispatch();
  const modalizeRef = useRef(null);
  const isShow = useSelector(
    (state) => state.modal.addToBagPreOrderWarning.isShow,
  );
  const product = useSelector(
    (state) => state.modal.addToBagPreOrderWarning.data,
  );
  const qtyProduct = useSelector((state) => state.productDetail.qtyProduct);
  const defaultCombination = useSelector(
    (state) => state.productDetail.defaultCombination,
  );
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const Utils = product
    ? new ProductUtils(product)
    : { getAddToBagFlowStatus: () => {} };
  const addToBagFlowStatus = Utils.getAddToBagFlowStatus();
  const [disabledAddToBag, setDisabledAddToBag] = useState(false);

  const isProductCombinationReadyToAdd = Boolean(
    defaultCombination?._id &&
      addToBagFlowStatus === 'modal_multi_cart' &&
      product.classification !== 'bundle_virtual',
  );
  const closeModal = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'addToBagPreOrderWarning' });
  };

  const addToBagHandler = () => {
    if (isShow) {
      closeModal();
    }

    const payload = {
      product: {
        id: product.id,
        combination_id: product.default_combination._id,
        quantity: qtyProduct,
        is_confirm: true,
      },
      is_confirm: true,
      action: 'add',
    };
    const is_pack =
      product.classification === 'bundle_virtual' &&
      product.pack_detail &&
      product.pack_detail.filter(
        (res) => res.combinations && res.combinations.length === 1,
      );
    if (is_pack && is_pack.length) {
      payload.product = {
        ...payload.product,
        is_pack: true,
        is_confirm: true,
        pack: product.pack_detail.map((data) => {
          return {
            combination_id: data.combinations[0]._id,
            product_id: data.id,
            quantity: data.quantity,
          };
        }),
      };
    }

    if (addToBagFlowStatus === 'modal_single_cart') {
      addSelectedCombinationToCart(payload, 'buy_now');
    } else if (isProductCombinationReadyToAdd) {
      // if combination is already selected, no need to show popup to select again
      payload.product.combination_id = defaultCombination._id;
      addSelectedCombinationToCart(payload, 'buy_now');
    } else {
      // if has more than one combination / bundle need to choose combination
      // console.log('going to modal_multi_cart')
      dispatch({
        type: 'MODAL/SHOW',
        modalName: 'addToCart',
        data: {
          productData: product,
          navigation,
        },
      });
    }
  };

  const addSelectedCombinationToCart = (payload, type) => {
    // if no / single combination / default selected combination / bundle without need to choose combination
    setDisabledAddToBag(true);

    if (isLoggedIn) {
      GoogleTagManager.addToCart(product, payload.product.quantity);
    }

    // adding detail data for product added to cart when user wasn't logged in
    if (!isLoggedIn) {
      payload.product.detailData = Utils.getDetailDataNotLogin(product);
    }

    dispatch(cartActions.addProductToCart(payload)).then((res) => {
      if (!res.error) {
        closeModal();
        if (type === 'buy_now') {
          navigation.current.navigate('ShoppingBagScreen');
        } else {
          dispatch({
            type: 'MODAL/SHOW',
            modalName: 'productAdded',
            data: {
              productData: product,
              attributes: defaultCombination?.attributes,
              navigation,
            },
          });
        }
      }
      setDisabledAddToBag(false);
    });
  };

  useEffect(() => {
    if (isShow) {
      modalizeRef.current?.open();
    } else {
      modalizeRef.current?.close();
    }
  }, [isShow]);

  return (
    <Modal overlayStyle={{ maxWidth: 328 }} isVisible={isShow}>
      <Suspense fallback={<></>}>
        <View style={styles.modalContainer}>
          <View style={styles.modalHeader}>
            <Text style={styles.modalHeaderHeading}>Attention</Text>
          </View>

          <View style={styles.modalBody}>
            {product?.preOrderDifferentDeliveryDate ? (
              <Text style={styles.text}>
                Kamu sudah memasukkan produk pre-order ke dalam shopping bag.
                Namun, produk pre-order yang berbeda waktu pengiriman tidak
                dapat digabung dengan produk pre-order lainnya.
              </Text>
            ) : (
              <Text style={styles.text}>
                Pembelian produk Pre-Order tidak dapat digabung dengan produk
                lainnya. Jika kamu mempunyai produk yang telah dimasukkan ke
                dalam shopping bag sebelumnya, maka otomatis terhapus.
              </Text>
            )}
          </View>

          <View style={styles.modalFooter}>
            <View style={styles.groupButton}>
              <Button
                buttonStyle={styles.buttonStyleCancel}
                titleStyle={styles.titleStyleCancel}
                title="Cancel"
                onPress={closeModal}
              />
              <Button
                buttonStyle={styles.buttonStyle}
                disabledStyle={styles.buttonStyle}
                title="Add to Bag"
                onPress={addToBagHandler}
                disabled={disabledAddToBag}
              />
            </View>
          </View>
        </View>
      </Suspense>
    </Modal>
  );
};

const styles = StyleSheet.create({
  buttonStyle: {
    width: 138,
  },
  buttonStyleCancel: {
    width: 138,
    backgroundColor: '#FFFFFF',
  },
  titleStyleCancel: {
    color: '#404040',
  },
  groupButton: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  modalBody: {
    paddingHorizontal: 20,
    paddingBottom: 16,
  },
  modalFooter: {
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
  modalContainer: {
    width: 328,
  },
  modalHeader: {
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 12,
    position: 'relative',
    width: '100%',
  },
  modalHeaderHeading: {
    ...Font.satoshiBlack,
    fontSize: 16,
    lineHeight: 24,
    color: '#25182E',
  },
  text: {
    ...Font.satoshiMedium,
    color: '#6F6F6F',
    fontSize: 12,
    lineHeight: 20,
  },
});

export default React.memo(ModalAddToBagPreOrderWarning);
